module.exports = __webpack_public_path__ + "img/person-seat-reclined.4960ebc8.svg";